import { GetterTree } from 'vuex';
import { AppTheme } from '@/features/common/constants';
import { getAppTheme } from '@/features/common/helpers/whiteLabel';
import { NotificationPrefType, UserPreferences } from '@/features/settings/types';
import { UserInfo } from '@/features/users/types';
import { RootState } from '../types';
import { historyTableColumns } from '../raw';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<RootState, any> = {
  getCountryFromCode(state: RootState) {
    return (code: string) => {
      return state.countries.find((country) => country.code === code);
    };
  },

  // TODO: move to preferences module
  getUserPreferences(state: RootState): UserPreferences {
    return state.userPreferences;
  },

  // TODO: move to preferences module
  getNotificationPrefs(state: RootState): NotificationPrefType[] {
    return state.notificationPrefs;
  },

  // TODO: move to preferences module
  getIsUserPreferences(state: RootState): number {
    return state.isUserPreferences;
  },

  // TODO: move to preferences module
  getIsNotificationPrefs(state: RootState): boolean {
    return state.isNotificationsPrefs;
  },

  // TODO: move to preferences module
  getHistoryTableColumns(state: RootState): string[] {
    const { shipmentHistorySettings } = state.userPreferences;
    if (!shipmentHistorySettings) return historyTableColumns;

    return shipmentHistorySettings.columnOrder ?? historyTableColumns;
  },

  getHideDoNotShow(state: RootState): boolean {
    return !!state.notificationPrefs.find((notification) => notification.name === 'HideDoNotShow')?.show;
  },

  // TODO: move to users module
  getUserInfo(state: RootState): UserInfo {
    return state.userInfo;
  },

  // TODO: move to users module
  getShowSuccessShip(state: RootState): boolean {
    return !!state.userInfo.isShowShipForSuccess;
  },

  getAppTheme(): AppTheme {
    return getAppTheme();
  },

  getIsInitialDataLoaded(state: RootState): number {
    return state.isInitialDataLoaded;
  },
};

export default getters;
